import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

const inputCls = "w-full bg-[#0d0e12] border border-[#232530] px-4 py-3 text-[#ede8e1] font-light placeholder:text-[#57534e] focus:border-[#581313] focus:outline-none transition-colors";

export const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.emailed
        ? "Your letter was sealed and dispatched to the Keeper."
        : "Your letter rests in the Vault. The Keeper will read it soon.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <motion.section
      id="contact"
      initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative z-10 py-20 lg:py-28 border-t border-[#232530]"
      data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="font-mono text-xs tracking-[0.35em] uppercase text-[#581313] mb-4">06 // CORRESPONDENCE</p>
          <h2 className="font-serif font-light text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#ede8e1]">
            Send a letter into the dark
          </h2>
          <p className="mt-4 text-[#a8a29e] font-light max-w-md">
            Commissions, collaborations, or quiet discourse — every letter is read by candlelight and answered in kind.
          </p>
        </div>
        <form onSubmit={submit} className="lg:col-span-7 space-y-5" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-5">
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Your name" className={inputCls} data-testid="contact-name-input" />
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Your email" className={inputCls} data-testid="contact-email-input" />
          </div>
          <input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
            placeholder="Subject of your inquiry" className={inputCls} data-testid="contact-subject-input" />
          <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
            placeholder="Compose your letter…" className={`${inputCls} resize-none`} data-testid="contact-message-input" />
          <button type="submit" disabled={sending} data-testid="contact-submit-button"
            className="bg-[#581313] hover:bg-[#581313] disabled:opacity-50 text-[#ede8e1] border border-[#581313]/40 font-mono text-xs uppercase tracking-widest px-8 py-3 transition-colors">
            {sending ? "Sealing…" : "Seal & Dispatch"}
          </button>
        </form>
      </div>
    </motion.section>
  );
};
